import configure from "./configure";
import stringify from "./query";

const { setHeadersWithAuth, axios } = configure;

export const getDrugs = async ({ idList, formType, token }) => {
  const query = stringify({ idList, formType });
  const headers = setHeadersWithAuth(token);
  return axios.get(`/drugs/${query}`, headers).then(
    (res) => {
      return res;
    },
    (error) => {
      return error;
    },
  );
};

export const createDrugs = async ({ formList, token }) => {
  const headers = setHeadersWithAuth(token);
  const body = { formList };
  return axios.post(`/drugs`, body, headers).then(
    (res) => {
      return res;
    },
    (error) => {
      return error;
    },
  );
};

export const updateDrugs = async ({ formList, token }) => {
  const headers = setHeadersWithAuth(token);
  const body = { formList };
  return axios.patch(`/drugs`, body, headers).then(
    (res) => {
      return res;
    },
    (error) => {
      return error;
    },
  );
};

export const upsertDrugs = async ({ formList, token }) => {
  const headers = setHeadersWithAuth(token);
  const body = { formList };
  return axios.put(`/drugs`, body, headers).then(
    (res) => {
      return res;
    },
    (error) => {
      return error;
    },
  );
};

export const deleteDrugs = async ({ idList, token }) => {
  const headers = setHeadersWithAuth(token);
  return axios.delete(`/drugs/${idList}`, headers).then(
    (res) => {
      return res;
    },
    (error) => {
      return error;
    },
  );
};
